import { faChevronRight } from "@fortawesome/pro-regular-svg-icons"
import { ButtonBase, Divider, Stack, Typography } from "@mui/material"
import { styled } from "@mui/material/styles"
import theme, { FaIcon } from "@skistarab/mui-theme"

import { showMemberExplanation } from "@/utils/appshellEvents"

import { getMemberLevelIcon } from "./MemberLevelIconMap"

export type MemberBenefitBadgeProps = {
  memberLevelKey: string
  memberLevelName: string
  description: string
}

const DescriptionButton = styled(ButtonBase)(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: theme.spacing(0.5),
  padding: 0,
  minWidth: 0,
  "& .chevron-icon": {
    transition: "transform 0.16s ease-in-out 50ms",
  },
  "&:hover .MuiTypography-root": {
    color: theme.palette.primary.main,
  },
  "&:hover .chevron-icon": {
    transform: "translateX(3px)",
  },
}))

export const MemberBenefitBadge = ({
  memberLevelKey,
  memberLevelName,
  description,
}: MemberBenefitBadgeProps) => {
  const icon = getMemberLevelIcon(memberLevelKey)

  return (
    <Stack
      direction="column"
      sx={{
        width: "100%",
        backgroundColor: theme.palette.background.default,
      }}
      role="group"
      aria-label={`Member level: ${memberLevelName}, ${description}`}
    >
      <Stack direction="row" alignItems="center" spacing={1} sx={{ p: 1 }}>
        {icon}
        <Typography variant="h9" component="span" color="primary.dark">
          {memberLevelName}
        </Typography>

        <DescriptionButton onClick={showMemberExplanation}>
          <Typography variant="caption" sx={{ fontSize: "12px" }}>
            {description}
          </Typography>
          <FaIcon
            icon={faChevronRight}
            fontSize="inherit"
            color="primary"
            fontWeight={600}
            className="chevron-icon"
          />
        </DescriptionButton>
      </Stack>
      <Divider
        sx={{
          height: 3,
          background:
            "linear-gradient(90deg, #A8D6B0 0%, #8DC2F1 50%, #BA0C2F 100%)",
          border: "none",
        }}
      />
    </Stack>
  )
}

export default MemberBenefitBadge
